import { getRecordIssues } from '@/shared/api';
import type { ConvertPredicateResponse, PredicateValue } from '../api/types';

/** Что проверялось: описание условия на естественном языке или строгая запись */
export type PredicateInputSource = 'description' | 'record';

/**
 * Условие непригодно: запись есть, а условия из неё не получилось.
 * Проблемы кладёт в значение поле ввода условия — при построенном условии их нет.
 *
 * Значение принимается нетипизированным: правило валидации поля формы получает его
 * объединением типов всех полей формы.
 */
export const hasPredicateIssues = (value: unknown): boolean => {
  const issues = (value as PredicateValue | null | undefined)?.issues;
  return Array.isArray(issues) && issues.length > 0;
};

/**
 * Условие построено и его можно сохранять.
 *
 * У описания на естественном языке условия нет при любой проблеме: строгую запись из
 * описания делает языковая модель, и её отказ принять за условие нельзя — ответ отказа
 * приходит на месте записи. Строгую запись разбирает сам сервер, поэтому отказ модели
 * перевести её обратно в описание условию не мешает.
 */
export const isConditionBuilt = (
  response: Pick<ConvertPredicateResponse, 'dsl' | 'issues'>,
  source: PredicateInputSource,
): boolean => {
  const issues = response.issues ?? [];
  const blockingIssues = source === 'description' ? issues : getRecordIssues(issues);

  return Boolean(response.dsl) && blockingIssues.length === 0;
};
